import { render } from "./FavouriteFilters.vue?vue&type=template&id=ddc812c8"
import script from "./FavouriteFilters.vue?vue&type=script&lang=js"
export * from "./FavouriteFilters.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__